import { IFundraiser } from './../../../../fundraiser/models/fundraiser.model';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FundraiserService, VariablesService, UtilService, StorageService, PaymentService, EventsService, VwoService, ApiService } from '../../../../shared/services';
import { ActivatedRoute, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';
import { ICLientData, IUser } from 'src/app/shared/models';
import { PaymentUtilService } from '../../services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-payment-landing',
  templateUrl: './payment-landing.component.html',
  styleUrls: ['./payment-landing.component.scss']
})
export class PaymentLandingComponent implements OnInit, OnDestroy {

  subs: Subscription[] = [];
  fundraiser: IFundraiser;
  params;
  userData: IUser;
  clientData: ICLientData;
  currency;
  amount;
  page_loader = true;
  isMobile;
  themeResp : any;

  constructor(
    private fundraiserService: FundraiserService,
    private actRoute: ActivatedRoute,
    private api: ApiService,
    private vars: VariablesService,
    private util: UtilService,
    private storage: StorageService,
    private paymentService: PaymentService,
    private paymentUtilService: PaymentUtilService,
    private events: EventsService,
    public vwo: VwoService
  ) { }

  ngOnInit() {
    this.isMobile = this.util.isMobile();
    this.params = this.actRoute.snapshot.queryParams;
    this.currency = this.params?.currency || this.storage.getFromSession('currency') || 'INR';
    this.amount = +this.params?.amount || null;
    this.subs.push(this.vars.clientLocationData.subscribe((res) => this.clientData = res));
    this.util.scrollToTop();
    this.vars.campaignType = 'payment_page';
    if(this.params?.entity_type === 'ngo'){
      this.vars.mainLayoutConfig.next({
        showProfile: false,
        showHeader: true,
        showFooter: false,
        hideAbandonedCart: true,
        isStandaloneNgoPage: true,
        showSecure: true
      });
    } else {
      this.vars.mainLayoutConfig.next({
        showProfile: false,
        showHeader: false,
        showFooter: false,
        hideAbandonedCart: true
      });
    }
    this.getFundraiser();
  }

  getFundraiser() {
    this.userData = this.vars.varLoginData?.userdata || this.storage.get('userdata');
    const qParams = `?with=beneficiary;campaigner;storyTitle;tipModel&currency=${this.currency}`;
    this.fundraiserService.getCampaign(this.params?.ct, qParams).subscribe(async (res: any) => {
      this.vars.fundraiser = res.data;
      this.fundraiser = res.data;
      if (res?.data?.theme && res?.data?.logo && res?.data?.logo?.entity_type === 'ngo') {
        this.vars.theme.next({
          'primary_color': res?.data?.theme?.info_1,
          'text_color': res?.data?.theme?.info_2,
          'logo': res?.data?.logo?.cdn_path,
          'access_url': res?.data?.access_url,
          'entity_type': res?.data?.logo?.entity_type,
          'website_url': res?.data?.beneficiary?.website_1
        });
      }
      this.setPayment();
      const isFundraiserEnded = this.util.checkFundraiserEnded(res.data.status_flag, res.data.end_date);
      if (isFundraiserEnded) {
        this.util.router.navigate(['/crowdfunding/fundraisers']);
        this.util.openSnackBar('Fundraiser is ended, please check others', 'error');
      }
    }, () => this.util.navigate('/new/404'));
  }

  async setPayment() {
    // if (this.fundraiser?.id === environment.health_first_campaign_id && this.userData) {
    //   this.vars.pageName = 'healthfirst_payment_standalone';
    //   this.currency = 'INR';
    //   let sel_insurance = this.util.setSelectedInsurance({ frequency: 'yearly', currency: this.currency }, this.params);
    //   const cart_data = this.storage.getFromSession('cartData');
    //   if (cart_data
    //     && cart_data?.campaign_id === environment.health_first_campaign_id
    //     && cart_data?.donated_amount === this.vars.selected_insurance?.plan_amount
    //     && cart_data?.plan === this.vars.selected_insurance.plan
    //     && cart_data?.vendor === this.vars.selected_insurance.vendor
    //     && cart_data?.timestamp && ((cart_data?.timestamp + (60000 * 10)) > new Date().getTime())) { // check if cart created within 10min
    //     this.paymentUtilService.cartResponse.next(cart_data);
    //     this.vars.createCart = false;
    //   } else {
    //     this.storage.deleteFromSession('cartData');
    //     this.vars.createCart = true;
    //   }
    //   this.hfSetPayment();
    //   this.vars.switch_plan.next(this.vars.selected_insurance.plan);
    //   this.subs.push(this.vars.switch_plan.subscribe(async p => {
    //     if (p && p !== this.vars.selected_insurance.plan) {
    //       sel_insurance = this.util.setSelectedInsurance({ plan: p });
    //       await this.validateCoupon();
    //       this.hfSetPayment();
    //     }
    //   }));
    //   this.util.router.events.subscribe((event: NavigationStart) => {
    //     if (event.navigationTrigger === 'popstate') {
    //       try {
    //         const ref = atob(this.params?.referal)
    //         if (ref) {
    //           this.util.nativeNavigation(environment.APP.DOMAIN_URL + ref);
    //           return;
    //         }
    //       } catch (error) { }
    //       if (event.url.match('ref=healthfirst')) {
    //         // redirect to healthfirst price breakup
    //         this.util.router.navigate(['/healthfirst/price-breakup'], {queryParams: { plan: this.params?.plan?.toLocaleLowerCase() }});
    //       } else if (event.url.match('payment=form')) {
    //         this.util.router.navigate([], { queryParams: { payment: 'option' }, queryParamsHandling: 'merge' });
    //         this.util.nativeNavigation(environment.sipretention_domain + '/healthfirst');
    //       }
    //     }
    //   });
    // } else if (this.fundraiser?.id === environment.health_first_campaign_id && !this.userData) {
    //   setTimeout(() => {
    //     this.util.router.navigate(['/new/signin'], {
    //       queryParams: {
    //         redirect_uri: this.util.router.url.split('?')[0]
    //       },
    //       queryParamsHandling: 'merge'
    //     }).then(() => {
    //       console.log(this.util.router.url);
    //     });
    //     this.page_loader = false;
    //   }, 100);
    // } else {
      this.page_loader = false;
    // }
    this.pageViewEvent();
  }

  // hfSetPayment() {
  //   this.amount = this.vars.selected_insurance.plan_amount;
  //   this.vars.event_info.info_1 = this.vars.selectedIllness?.person ? this.vars.selectedIllness.person + '; ' + this.vars.selectedIllness.illnessAmount : '';
  //   this.vars.event_info.info_3 = this.vars.selected_insurance.plan_text + ' Plan; ' + this.amount;
  //   if (!this.isMobile) {
  //     this.paymentUtilService.initaiteQr = true;
  //   }
  //   this.getPaymentOptions();
  // }

  // getPaymentOptions() {
  //   let params = `&mobile_no=${this.userData?.phone_1}&is_mobile=${this.util.isMobile() ? 1 : 0}&amount=${this.amount}`;
  //   this.paymentService.getPaymentOptions(this.currency, params).subscribe((res: any) => {
  //     this.paymentUtilService.paymentOptionsObs.next(res.data);
  //     if (Object.keys(res.data.options).length === 1) {
  //       for (const [key] of Object.entries(res.data.options)) {
  //         const paymentOption = key.charAt(0).toLowerCase();
  //         this.util.router.navigate([], {
  //           queryParams: { payment: 'options', op: paymentOption },
  //           queryParamsHandling: 'merge'
  //         });
  //         break;
  //       }
  //     } else {
  //       this.util.router.navigate([], {
  //         queryParams: { payment: 'options', op: this.util.isMobile() && this.currency !== 'INR' ? 'c' : null },
  //         queryParamsHandling: 'merge'
  //       });
  //     }
  //     this.page_loader = false;
  //   });
  // }

  validateCoupon() {
    return new Promise((resolve) => {
      if (!this.params?.coupon_code || !this.userData) {
        resolve(true);
        return;
      }
      this.vars.couponDetails = null;
      const url = environment.APP.API_URLS.VALIDATE_COUPON_CODE(this.userData.id, this.params.coupon_code) + `?type=insurance&vendor=medibuddy&currency=${this.currency}&donated_amount=${this.vars.selected_insurance?.plan_amount}&plan_id=${this.vars.selected_insurance?.plan_id}&showError=false`;
      this.api.get(url).subscribe({
        next: async (resp) => {
          if (resp?.data?.discount_amount) {
            this.vars.couponDetails = {
              coupon_code: resp?.data?.coupon_code,
              discount_amount: resp?.data?.discount_amount,
              payable_amount: resp?.data?.payable_amount
            };
          }
          resolve(true);
        },
        error: () => {
          resolve(true);
        }
      });
    });
  }

  pageViewEvent() {
    const pageViewPayload = {
      eventName: 'pageView',
      info_3: this.vars.event_info.info_3
    };
    this.events.onLoadSystemEvent(pageViewPayload);
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }

}
